import { rest } from 'catering/api';
import { buildApiEndpoint } from 'helpers/apiHelpers';

const ACCOUNT_BASE_ENDPOINT = buildApiEndpoint('/api/catering/account');

export const ACCOUNT_GET_ENDPOINT = `${ACCOUNT_BASE_ENDPOINT}/`;

export async function getAccount() {
  return rest.get(ACCOUNT_GET_ENDPOINT);
}
